import React from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";

const reports = [
  {
    id: 1,
    title: "Anket Çalışması 1",
    description: "Yeşil Dönüşüm ve Sürdürülebilirlik Anketi",
    date: "2024-11-19",
    filePath: "/belgeler/Yeşil Dönüşü ve Sürdürülebilirlik Anketi hk..docx"
  }
];

const AdminBelgeler = () => {
  const handleDownload = (filePath: string) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.download = filePath.split("/").pop() || "file";
    link.click();
  };

  return (
    <div className="grid p-1 sm:p-3 justify-content-center">
      {reports.map((report) => (
        <div key={report.id} className="col-12 sm:col-6 lg:col-4">
          <Card
            title={report.title}
            className="h-full flex flex-column shadow-1 border-round-xl"
            footer={
              <div className="card-footer mt-auto">
                <Button
                  label="Belgeyi İndir"
                  icon="pi pi-download"
                  className="p-button-outlined w-full"
                  onClick={() => handleDownload(report.filePath)}
                />
              </div>
            }
          >
            <p className="mt-2 text-600 line-height-3 text-sm flex-1">{report.description}</p>
            <div className="text-right text-xs text-500 font-semibold mt-2">{report.date}</div>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default AdminBelgeler;
